<template>
  <Row class="info-row">
    <Col span="13" class="cost-key">{{ field }}</Col>
    <Col span="6" class="cost-price">{{ displayValue }}</Col>
    <Col span="5" :style="diffStyle">{{ displayDiffValue }}</Col>
  </Row>
</template>

<script>
export default {
  props: ["value", "diffValue", "isPercentage", "typeTwo", "field"],
  name: "CalcCostInfoRow",
  data() {
    return {};
  },
  computed: {
    displayValue: function () {
      if (!this.value) return "-";
      if (this.isPercentage) {
        return (this.value * 100).toFixed(2) + "%";
      } else {
        return this.value.toFixed(0);
      }
    },
    displayDiffValue: function () {
      if (!this.diffValue) return "-";
      let v = this.diffValue > 0 ? "+" : "";
      if (this.isPercentage) {
        return v + (this.diffValue * 100).toFixed(2) + "%";
      } else {
        return v + this.diffValue.toFixed(0);
      }
    },
    diffStyle: function () {
      const style = { color: "black" };
      if (this.diffValue > 0) {
        style.color = this.typeTwo ? "green" : "red";
      } else if (this.diffValue < 0) {
        style.color = this.typeTwo ? "red" : "green";
      } else {
        style.color = "lightgray";
      }
      return style;
    },
  },
  methods: {},
};
</script>

<style lang="stylus" scoped>
.cost-key
  cursor pointer

.cost-key ~ div
  text-align right

.info-row:hover
  background-color rgb(255, 251, 229)
  border-bottom 1px solid brown

.info-row
  border-bottom 1px solid #F1F3F4
</style>